"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDefinition = void 0;
const lodash_1 = require("lodash");
const locales_1 = require("../../utils/locales");
////////////////////////////////////////////////////////////////////////////////
// Raw definition is actually parsed and transformed at compile time.
function parseDefinition(definition) {
    // Normalize and validate the list of locales
    let localesDefinitions = toArrayOfObjectForm(definition.locales, 'localeCode');
    if (localesDefinitions === null)
        throw new Error(`locales must be either an object or an array`);
    if (localesDefinitions.length === 0)
        throw new Error('Localization definition must define at least one locale');
    let localeEntries = localesDefinitions.map((localeDefinition) => {
        let { localeCode, basePath } = localeDefinition, localeAttributes = __rest(localeDefinition, ["localeCode", "basePath"]);
        let { langCode, countryCode } = (0, locales_1.decodeLocaleCode)(localeCode);
        let bcp47LocaleCode = `${langCode.toLowerCase()}-${countryCode.toUpperCase()}`;
        if (!!basePath && basePath.length > 0) {
            if (basePath.charAt(0) !== '/')
                basePath = '/' + basePath;
            if (basePath.charAt(basePath.length - 1) === '/')
                basePath = basePath.slice(0, basePath.length - 1);
        }
        else {
            basePath = `/${countryCode.toLocaleLowerCase()}/${langCode.toLowerCase()}`;
        }
        return {
            localeCode,
            bcp47LocaleCode,
            langCode,
            countryCode,
            basePath,
            attributes: localeAttributes,
        };
    });
    let duplicatedLocales = findDuplicates(localeEntries, 'localeCode');
    if (duplicatedLocales.length > 0)
        throw new Error(`Duplicated locales: '${duplicatedLocales[0]}'`);
    let keyedEntries = (0, lodash_1.keyBy)(localeEntries, 'localeCode');
    // Validate the default locale
    if (!(0, lodash_1.isString)(definition.defaultLocale))
        throw new Error(`No default locale is set`);
    if (!keyedEntries[definition.defaultLocale])
        throw new Error(`Default locale refers to a locale that is not in defined locales`);
    let defaultLocale = definition.defaultLocale;
    // let distinctLanguagesCode = _.uniq(_.map(locales, _.property('langCode')));
    // let distinctCountriesCode = _.uniq(_.map(locales, _.property('countryCode')));
    // let basePath : string[] = [];
    // basePath =
    return {
        defaultLocale,
        locales: keyedEntries,
        // ,
    };
}
exports.parseDefinition = parseDefinition;
////////////////////////////////////////////////////////////////////////////////////////////////////
// Internal utility functions
////////////////////////////////////////////////////////////////////////////////////////////////////
function toArrayOfObjectForm(source, identifierAttribute) {
    if ((0, lodash_1.isPlainObject)(source)) {
        return (0, lodash_1.toPairs)(source).map(([identifier, remainingProperties]) => {
            return Object.assign({ [identifierAttribute]: identifier }, remainingProperties);
        });
    }
    else if (Array.isArray(source)) {
        return source.map((x) => typeof x === 'string'
            ? { [identifierAttribute]: x }
            : x);
    }
    else
        return null;
}
function findDuplicates(array, property) {
    return (0, lodash_1.toPairs)((0, lodash_1.countBy)(array, property))
        .filter(([_identifier, count]) => count > 1)
        .map(([identifier, _count]) => identifier);
}
//# sourceMappingURL=localization-context-definition.js.map